import Home from '@/pages/admin/Home'
import ParkQuizValidationList from '@/pages/quizzes/ParkQuizValidationList'
import ParkQuizValidation from '@/pages/quizzes/ParkQuizValidation'

const routes = [
  {
    path: '/admin',
    name: 'AdminHome',
    component: Home,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  },
  {
    path: '/park-quiz-validation-list',
    name: 'ParkQuizValidationList',
    component: ParkQuizValidationList,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  },
  {
    path: '/park-quiz-validation/:parkId/:referenceYear/:quizUuid/:parkName?',
    name: 'ParkQuizValidation',
    component: ParkQuizValidation,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    },
    props: true
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/admin.js